module.exports = __webpack_public_path__ + "static/dental-7141789150d292bdae9f3fe0bdb696ef.png";